import { gql } from '@apollo/client'

import { FormFragment } from '../fragments'

export const MUTATION_CREATE_FORM = gql`
  mutation createForm($input: FormCreateInput!) {
    createForm(input: $input) {
      ...FormFragment
    }
  }
  ${FormFragment}
`

export const MUTATION_UPDATE_FORM = gql`
  mutation updateForm($input: FormUpdateInput!) {
    updateForm(input: $input) {
      ...FormFragment
    }
  }
  ${FormFragment}
`

export const MUTATION_DUPLICATE_FORM = gql`
  mutation duplicateForm($input: FormDuplicateInput!) {
    duplicateForm(input: $input) {
      ...FormFragment
    }
  }
  ${FormFragment}
`

export const MUTATION_SAVE_FORM = gql`
  mutation saveForm($input: FormSaveInput!) {
    saveForm(input: $input) {
      ...FormFragment
    }
  }
  ${FormFragment}
`

export const MUTATION_SUBMIT_FORM = gql`
  mutation submitForm($input: FormSubmitInput!) {
    submitForm(input: $input) {
      ...FormFragment
    }
  }
  ${FormFragment}
`

export const MUTATION_UPDATE_FORM_STATUS = gql`
  mutation updateFormStatus($input: FormStatusUpdateInput!) {
    updateFormStatus(input: $input) {
      ...FormFragment
    }
  }
  ${FormFragment}
`

export const MUTATION_DELETE_FORM = gql`
  mutation deleteForm($id: ID!) {
    deleteForm(id: $id)
  }
`

export const MUTATION_UPDATE_FORM_POSITIONS = gql`
  mutation updateFormPositions($input: FormPositionsUpdateInput!) {
    updateFormPositions(input: $input) {
      ...FormFragment
    }
  }
  ${FormFragment}
`
